import { LIMITED_INVENTORY, STANDARD_INVENTORY } from '../../../../brandSafetyOptions'
import {
  APP_PROMOTION,
  ENGAGEMENT,
  LEAD_GENERATION,
  REACH,
  TRAFFIC,
  VIDEO_VIEWS,
  WEB_CONVERSIONS
} from '../../../../../../../../../constants/campaigns'

export const getShowCategoryExclusionsDropdowns = (campaignObjective = '', brandSafety) => {
  return (
    ((brandSafety === STANDARD_INVENTORY || brandSafety === LIMITED_INVENTORY) &&
      campaignObjective.toLowerCase() === REACH) ||
    campaignObjective.toLowerCase() === VIDEO_VIEWS ||
    campaignObjective.toLowerCase() === ENGAGEMENT
  )
}

export const getShowPurchaseIntentionCategories = (campaignObjective = '') => {
  switch (campaignObjective.toLowerCase()) {
    case WEB_CONVERSIONS:
    case LEAD_GENERATION:
    case TRAFFIC:
    case APP_PROMOTION:
      return true
    default:
      return false
  }
}
